import { useEffect } from 'react';
import { CheckCircleOutlineRounded } from '@mui/icons-material';
import { Box, Button, Divider, Grid2, SvgIcon, Typography } from '@mui/material';
import logo from 'assets/images/logo/utriper-black-logo.png';
import { useTranslation } from '../../../../core/contexts/localization';
import { navigateTo } from '../../../../core/navigate';

const PaymentSuccess = ({ redirectURL, autoRedirect = false, userEmail }) => {
    const { t: translate } = useTranslation();
    const defaultUrl = 'https://experiences.utriper.com';

    // Only a contract-sourced URL sets autoRedirect (resolved in apiserver, roadmap#686).
    // Everything else keeps the button, which is the behaviour every non-contract purchase
    // has today. Guarded on redirectURL too: a contract whose field was cleared must not
    // send anyone to `undefined`.
    useEffect(() => {
        if (autoRedirect && redirectURL) {
            navigateTo(redirectURL);
        }
    }, [autoRedirect, redirectURL]);

    const handleClick = () => {
        navigateTo(redirectURL || defaultUrl);
    };

    return (
        <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box display="flex" flexDirection="column" maxHeight="90%" padding="2.5em" sx={{ maxWidth: { xs: '85%', sm: '50%' }, border: 'solid 3px #A6BA62', borderRadius: '1em', position: 'relative' }}>
                <Grid2 mt={2}>
                    <SvgIcon style={{ height: '4rem', width: '4rem', color: '#A6BA62', display: 'flex', marginInline: 'auto', marginBottom: '1rem' }}>
                        <CheckCircleOutlineRounded />
                    </SvgIcon>
                </Grid2>
                <Grid2 container flexDirection="column" justifyContent="center" alignItems="center" spacing={4}>
                    <Grid2>
                        <Typography variant="h2" sx={{ fontSize: { xs: '1.2em', md: '1.5em' }, fontWeight: 600 }}>
                            {translate('templates.purchase.paymentSuccess')}
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant="h2" sx={{ fontSize: { xs: '1.2em', md: '1.5em' }, fontWeight: 600, opacity: '90%' }}>
                            {translate('templates.purchase.title')}
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant="h2" sx={{ fontSize: { xs: '1.2em', md: '1.5em' }, fontWeight: 600, opacity: '90%' }}>
                            {`${translate('templates.purchase.beforeBodyEmail')} ${userEmail || 'correo@utriper.com'} ${translate('templates.purchase.afterBodyEmail')}`}
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant="h2" sx={{ fontSize: { xs: '1.2em', md: '1.5em' }, fontWeight: 600 }}>
                            {translate('templates.purchase.enjoy')}
                        </Typography>
                    </Grid2>
                </Grid2>
                <Divider sx={{ border: 'solid .5px #777', margin: '3em 0' }} />
                <Grid2 container flexDirection="column" justifyContent="center" alignItems="center" spacing={4} mb={4}>
                    <Typography variant="h2" sx={{ fontSize: { xs: '1.2em', md: '1.5em' }, fontWeight: 600 }}>
                        {translate('templates.purchase.beforeEmail')} <a href="mailto:hello@utriper.com">hello@utriper.com</a> {translate('templates.purchase.afterEmail')}
                    </Typography>
                    <Button variant="contained" color="primary" sx={{ marginRight: 'auto' }} onClick={handleClick}>
                        {translate('utils.backToSite')}
                    </Button>
                </Grid2>
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        backgroundImage: `url("${logo}")`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        width: '6rem',
                        height: '2rem',
                        margin: '1rem',
                    }}
                />
            </Box>
        </div>
    );
};

export default PaymentSuccess;
